// src/utils/submissionUtils.js

export const processSubmission = async ({
  submissionId,
  paymentData,
  challengeId,
  currentUser,
  title,
  description,
  fundingGoal,
  tags,
  challengeData,
  profileData,
  setSnackbarMessage,
  setSnackbarOpen,
  saveDraft,
  initiatePurchase,
  draftData, // Ensure draftData is passed
}) => {
  try {
    console.log("Processing submission with payment data:", paymentData);

    // Prepare the purchase data for the API request
    const purchaseData = {
      transactionId: paymentData.id,
      amount: paymentData.purchase_units[0].amount.value,
      status: paymentData.status,
      payerEmail: paymentData.payer.email_address,
      challengeId: challengeId,
    };

    // Call the initiatePurchase service to submit the purchase
    const result = await initiatePurchase(purchaseData);
    console.log("Purchase completed successfully:", result);

    // Merge existing draftData with new payment data and other fields
    const draftPayload = {
      ...draftData, // Preserve existing data
      title: title || draftData.title, // Ensure title is preserved if empty
      description: description || draftData.description,
      fundingGoal: fundingGoal || draftData.fundingGoal,
      tags: tags.length > 0 ? tags : draftData.tags, // Preserve if tags are empty
      paymentData: paymentData, // Add payment data to the draft
      status: "draft", // Ensure the status is set appropriately
      updatedAt: new Date(),
      challengeData: { ...challengeData },
      profileData: { ...profileData },
    };

    console.log("Updated Draft Payload:", draftPayload);

    // Update the existing draft without draftIdStorageKey
    await saveDraft({
      submissionId,
      currentUser,
      draftPayload,
      setSnackbarMessage,
    });

    // Display a success message
    setSnackbarMessage("Submission fee payment successful. You may proceed.");
    setSnackbarOpen(true);
  } catch (error) {
    console.error("Error processing submission:", error);
    setSnackbarMessage("Failed to process the submission. Please try again.");
    setSnackbarOpen(true);
  }
};
